<template>
  <div class="">
    <v-header ref="dudu"></v-header>
    <div class="beijngsd">
      <span></span>
      志愿单预览
      <span></span>
    </div>
    <div class="manpin">
      <div class="main centen container">
        <leftmenu></leftmenu>
        <!-- 在class为main_r里面写页面就行 -->
        <div class="main_r" ref="main_r">
          <div class="mainr_top">
            <div class="wenz_l">
              <img src="../images/geren16.png">{{$utils.getShowYear()}}年志愿生成表
            </div>
            <div class="wenz_r">
              <div class="wenz_r_l" style="background: #00B54F;" @click="save" :loading="saveFlag">
                保存志愿单
              </div>
              <el-button type="primary" class="wenz_r_l" style="border: 0px;" :loading="exportFlag"
                @click="ExportExcel">导出志愿单</el-button>
              <!-- <div class="wenz_r_l" @click="ExportExcel" >
                导出志愿单
              </div> -->
              <div class="wenz_r_r" @click="handleExport">
                打印志愿单
              </div>
            </div>
          </div>
          <!-- 志愿生成表 -->
          <div class="generateAssess ">
            <div class="assess">
              <span
                :style="$utils.getrateStyle(volunteerTableInfo.volunteerRate)">{{volunteerTableInfo.volunteerRate}}</span>
              <h5 :style="$utils.getrateStyle(volunteerTableInfo.volunteerRate)">评估得分</h5>
            </div>
            <em></em>
            <div class="list">
              <div class="item">
                学生姓名：<span>{{volunteerTableInfo.spare3}}</span>
              </div>
              <div class="item">
                分数：<span>{{volunteerTableInfo.volunteerScore}}分</span>
              </div>
              <div class="item">
                位次：<span>{{volunteerTableInfo.volunteerScoreRank}}</span>
              </div><br>
              <div class="item">
                选考科目：<span>{{SUBJECTTYPEOBJ[volunteerTableInfo.volunteerSubject]}}</span>
              </div>
              <div class="item">
                批次：<span>{{volunteerTableInfo.volunteerBatch}}</span>
              </div>
              <div class="item">
                省控线：<span>{{volunteerTableInfo.spare4}}</span>
              </div>

            </div>
            <div class="list" style="flex-direction: column;">
              <div class="item1">
                已选志愿：<span>{{list.length}}</span>
              </div>
              <div class="item1">
                已选院校：<span>{{collegenum}}</span>
              </div>
              <div class="item1">
                已选专业：<span>{{majornum}}</span>
              </div>

            </div>
          </div>
          <ul class="generateList">
            <li v-for="(item,index) in list" :key="index">
              <div class="xh" :style="$utils.getrateStyle(item.rate,1)">{{index+1}}</div>
              <div class="item">
                <div class="itemLeft flex-items" style="min-height: 148px;">
                  <div class="t1"  v-if="item.score!=null&&item.score.length!=0">
                    <span :style="$utils.getrateStyle(item.rate)">{{item.rate}}%</span>
                    <h5 :style="$utils.getrateStyle(item.rate)">概率</h5>
                  </div>
                  <div class="t1" v-else>
                    <div style="width: 55px;color: #F53824;line-height: 24px; font-size: 12px;">新增专业不做推荐自主填报</div>
                  </div>
                  <div class="t2">
                    <h4 style="font-size: 16px;width: 500px;display: flex;justify-content: start;">
                      <span class="myspan" v-if="$utils.getlocalStorage('showcode')"
                      style="border: 1px solid #F53824;background-color: white;border-radius: 18px;
                      padding: 0px 10px;font-size: 12px;margin-right: 10px;">
                        {{getempty(item.collegeCode)}}
                      </span>
                      <router-link tag="a" target="_blank" :to="'/xyzy_jianjie?num=0&id='+item.collegeId">
                        {{item.collegeName}}
                      </router-link>

                      <span class="myspan" v-if="item.collegeInfo!=null&&item.collegeInfo!=''"
                        style="margin-left:10px;">{{item.collegeInfo}}</span>
                      <div style="margin-left: 10px;">
                          <icollege :item="item"></icollege>
                      </div>
                    </h4>
                    <div class="flex-items shipeishangxia" style="margin-top:5px; width: 500px;">
                      <div class="dm" style="font-size: 12px;">
                        <span style="color: black;">{{AREA_OBJ[item.collegeArea]}} /
                        {{ item.collegeSubject }} /
                        <span :style="{color:item.collegeNature == 1?'':'red'}">{{item.collegeNature == 1?'公立':'民办'}}</span>
                        <span v-if="item.college!=null&&item.college.area!=null"> / {{ item.college.area }}</span>
                        </span>
                        <p>{{item.collegeNature !=1?'民办':''}}
                          {{item.collegeLevel!=null&&item.collegeLevel!=""?"/"+item.collegeLevel.replace(/,/g,'/'):''}}
                        </p>
                      </div>
                    </div>

                    <div class="flex-items shipeishangxia" v-if="tianbaoType != 1" style="width: 500px;justify-content: start;font-size: 13px;line-height: 30px;">
                      <div>分组：<span style="color: #F53824;">{{item.groupname}}</span><span style="color: #666666;margin-left: 10px;">({{item.collegeInfo}}111)</span></div>
                      <div style="margin-left: 20px;">选科：<span style="color: #F53824;">{{item.xuankeStr}}</span></div>
                    </div>

                    <div class="flex-items shipeishangxia" style="width: 500px;" v-if="tianbaoType == 1">
                      <div class="dm">
                        <div v-if="tianbaoType == 2" style="background-color: #29A7E1;border-radius: 10px;height: 20px;padding: 0px 5px;margin-right: 5px;">
                          <span style="font-size: 12px;line-height: 20px;color: #ffffff;">{{item.groupname}}</span>
                        </div>
                        <div style="background-color: red;color: #ffffff;
                        height: 18px;line-height: 18px; font-size: 10px;padding: 0 5px;border-radius: 8px;margin-right: 10px;"
                        >{{item.majorCode}}</div>

                        <p style="margin-right:10px">
                          {{item.majorName}}
                        </p>
                        <p style="margin-right:10px; color:#F53824" v-if="item.studyMoney!=null&&item.studyMoney!=''">
                          学费 : {{item.studyMoney}}
                        </p>
                        <imajor :item="item"></imajor>
                      </div>

                      <div style="margin-right: 125;font-size: 12px;">当年计划：<span
                          style="font-size:14px;color: #F53824;margin-right: 10px;" >{{getempty(item.planNum)}}</span>
                          <br/><span style="color: #F53824;">( {{item.xuankeStr}} )</span>
                      </div>
                    </div>

                    <div class="flex-items majorinfo" style="width: 500px;" v-if="tianbaoType == 1">
                      <p class="info">{{item.majorInfo}}</p>
                    </div>
                  </div>

                  <yiscore  :score="item.score" :year="scoreYear" v-if="item.flag"
                    style="width: 395px;"></yiscore>
                </div>

                <div class="itemRigth">
                  <div class="flex-items" v-show="!dochuflag" style="flex-direction: column;">
                    <a class="btn" style="width: 60px;" @click="updatesort(index,true)">上调</a>
                    <a class="add" style="margin: 5px 0;margin-left: 0px;" @click="add(index)">添加</a>
                    <a class="del" style="margin: 5px 0;margin-left: 0px;margin-top: 0;" @click="deleteZy(index)">删除</a>
                    <a class="btn" style="width: 60px;" @click="updatesort(index,false)">下调</a>
                  </div>
                </div>
              </div>
              <div id="box" class="zhankaiNeirong" v-if="(!item.show&&tianbaoType!=1)||dochuflag">
                <div class="zymajor" v-for="(major,index1) in item.list">
                  <div class="text" style="width:70px;">
                    <div class="t1" v-if="major.score!=null&&major.score.length!=0">
                      <span style="font-size: 18px;" :style="$utils.getrateStyle(major.rate)">{{major.rate}}%</span>
                      <h5>概率</h5>
                    </div>
                    <div class="t1" v-else>
                       <div style="width: 55px;color: #F53824;line-height: 24px; font-size: 12px;">新增专业不做推荐自主填报</div>
                    </div>
                  </div>
                  <div style="flex-direction: column;justify-content: space-between;width: 760px;display: flex;">
                    <div class="topBox">
                      <div class=" flex-items" style="min-width: 340px; flex-direction: column;display: flex;justify-content: space-evenly;align-items: flex-start;">
                        <div style="display: flex;flex-direction: row;
                          width: 335px;
                          align-items: center;justify-content: space-between;">
                            <h4>{{major.majorName}}</h4>
                            <imajor :item="major"></imajor>
                          </div>
                          <div>
                            <div style="flex-direction: row;display: flex; justify-content: space-between;width: 335px;">
                              <div style="margin-top: 10px;" v-if="$utils.getlocalStorage('showcode')">代码：<b style="color: #F53824;">{{getempty(major.majorCode)}}</b></div>
                              <div style="margin-top: 10px;" v-if="major.studyMoney!=null&&major.studyMoney!=null">学费：<b style="color: #F53824;">{{major.studyMoney}}</b></div>
                              <div style="margin-top: 10px;" >计划招生：<b style="color: #F53824;">{{getempty(major.planNum)}}</b></div>
                            </div>
                          </div>
                          <p style="width:360px;color: #999999;" v-if="major.majorInfo!=null&&major.majorInfo!=''">
                          {{major.majorInfo}}</p>
                        </div>
                        <yiscore :score="major.score" :year="scoreYear" v-if="major.flag" style="width: 395px;margin-left: 0px;"></yiscore>
                    </div>
                  </div>
                  <div class="flex-end" style="width:60px;" v-show="!dochuflag">
                    <div class="px" style="width: 60px;padding-left: 5px;" v-if="item.list.length != 1">
                      <span class="del" style="margin-left:0;" @click="changMajorsort(index,index1,true)"><img src="../images/x.png"
                          style="transform: rotate(180deg);"></span>
                      <span class="del" style="margin-top: 5px;margin-bottom:5px; margin-left: 0;" v-if="item.list.length != 1"
                        @click="delMajor(index,index1)">删除专业</span>
                      <span  class="del" style="margin-left:0;" @click="changMajorsort(index,index1,false)"><img src="../images/x.png"></span>
                    </div>

                  </div>
                </div>
              </div>
              <span v-if="tianbaoType != 1&&item.list!=null&&!dochuflag" class="zhankai"
                @click="openShutManager(index,item.id)">已选专业(<span>{{item.list.length}}</span>)个<img
                  src="../images/icon_xia.png"></span>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <item7></item7>
    <toast :title="title" :message="message" v-if="toastflag" @close="toastflag = false" @quxiao="toastflag=false"
      :flag="toastflag" :fun="fun" btn="que"></toast>
  </div>
</template>

<script>
  import vHeader from '../../components/vHeader.vue'
  import item7 from '../../components/item7.vue'
  import leftmenu from '../../components/leftmenu.vue'
  import toast from '../../components/toast.vue'
  import yiscore from '../yiscore.vue'
  import icollege from '../../components/icollege.vue'
  import imajor from '../../components/imajor.vue'
  import {
    downloadPDF
  } from "../../libs/pdf.js"
  export default {
    name: "",
    components: {
      vHeader,
      item7,
      leftmenu,
      toast,
      yiscore,
      icollege,
      imajor
    },
    data() {
      return {
        SUBJECTTYPEOBJ: this.$utils.getlocalStorage('SUBJECTTYPEOBJ'),
        AREA_OBJ: this.$utils.getlocalStorage('AREA_OBJ'),
        tianbaoType: 0,
        scoreInfo: this.$utils.getlocalStorage('scoreInfo'),
        userInfo: this.$utils.getlocalStorage('userInfo'),
        areaInfo: this.$utils.getlocalStorage('areaInfo'),
        list: [],
        map: {},
        collegenum: 0,
        majornum: 0,
        title: "",
        message: "",
        toastflag: false,
        fun: '',
        dochuflag: false,
        showflag: true,
        scoreYear: 2023,
        exportFlag: false,
        saveFlag:false,

        volunteerTableInfo: {},
      }
    },
    mounted() {
      this.volunteerTableInfo = this.$utils.getlocalStorage('volunteerTableInfo')
      let _this = this;
      _this.$http.get(_this.$resourcesUrl + "/data/ziyuandao.json?time=" + new Date().getTime()).then(function(
        resp) {
        _this.showflag = !resp.showflag

      })
      if(this.volunteerTableInfo.spare5 == null){
          _this.scoreYear = 2024
      } else {
        _this.scoreYear = parseInt(this.volunteerTableInfo.spare5)
      }
      _this.$http.get(_this.$resourcesUrl + "/data/VolunteerTable/" + this.volunteerTableInfo.userId + "/" + this
        .volunteerTableInfo
        .volunteerId + ".txt?time=" + new Date().getTime()).then(function(
        response) {
        _this.list = response
        console.log(_this.list)
        _this.getAlldata();
      })
      let area = _this.$utils.getlocalStorage('AREA_OBJ')[this.volunteerTableInfo.spare]
      let xuankeArea = _this.$utils.getlocalStorage('xuankeArea')
      if (xuankeArea.xingaokao.indexOf(area) == -1) {
        _this.tianbaoType = 0 //老高考
      } else if (xuankeArea.xingaokao2.indexOf(area) != -1 || xuankeArea.xingaokao3.indexOf(area) !=
        -1) {
        _this.tianbaoType = 2 //专业组
      } else {
        _this.tianbaoType = 1 //单专业
      }
      this.getArea();
    },
    methods: {

      getArea() {
        // let _this = this;
        // this.$req.selectOne("area", {
        //   id: this.areaInfo.areaId
        // }).then(function(response) {
        //   if (response.status == "0") {
        //     _this.$nextTick(()=>{
        //       _this.scoreYear = response.data.zyScoreyear
        //     })
        //   }
        // })
      },
      getAlldata() {
        let _this = this;
        let college = new Set();
        let major = new Set();

        this.list.forEach(function(item) {
          item.flag = true;
          college.add(item.collegeId)
          if (_this.tianbaoType != 1) {
            item.list.forEach(function(majorinfo) {
              majorinfo.flag = true;
              major.add(majorinfo.majorId)
            })
          } else {
            major.add(item.majorId)
          }
        })
        if (this.list.length == 0) {
          this.collegenum = 0
          this.majornum = 0
          this.volunteerTableInfo.volunteerRate = 0
        } else {
          this.volunteerTableInfo.volunteerRate = _this.list[_this.list.length - 1].rate
          this.collegenum = college.size
          this.majornum = major.size
        }
      },
      add(index){
        let _this = this;
        if(this.volunteerTableInfo.userId !=this.userInfo.userId){
          _this.title = "提示"
          _this.toastflag = true
          _this.message = "请先在“我的学生”中选择该学生，再进行志愿的调整"
          _this.fun = "to"
        } else {
          let map = {
            ZhiYuancyc:{ids:[],map:{}},
            ZhiYuanwyw:{ids:[],map:{}},
            ZhiYuanbyb:{ids:[],map:{}},
            ZhiYuandyd:{ids:[],map:{}},
          }

          this.list.forEach(function(item,index) {
            if(item.type == null||item.type == ''){
              item.type = _this.list[index-1].type
            }
            if(_this.tianbaoType == 2){

              map['ZhiYuan'+item.type].ids.push(item.id)
              item.ids = item.list.map(obj => obj.id);
              map['ZhiYuan'+item.type].map[item.id] = item
            } else {


              map['ZhiYuan'+item.type].ids.push(item.id)
              map['ZhiYuan'+item.type].map[item.id] = item
            }

          })

          this.$req.queryAllByLimit("provincialTable", {pageNum:1,pageSize:0,queryObj:{
            provincialArea: this.volunteerTableInfo.spare,
            provincialYear: parseInt(this.volunteerTableInfo.spare2),
            provincialBatch: this.volunteerTableInfo.volunteerBatch,
            provincialSubject: this.volunteerTableInfo.volunteerSubject
          }}).then(function(response) {
            if (response.status == "0") {
              let obj = JSON.parse(response.data[0].spare1)
              let obj1 = Object.assign(response.data[0].spare1, obj);
              _this.$rate.fxg = obj.fxg
              _this.$rate.cyc = obj.cyc
              _this.$rate.wyw = obj.wyw
              _this.$rate.byb = obj.byb

              _this.$utils.setlocalStorage("ZhiYuancyc",map.ZhiYuancyc);
              _this.$utils.setlocalStorage("ZhiYuanwyw",map.ZhiYuanwyw);
              _this.$utils.setlocalStorage("ZhiYuanbyb",map.ZhiYuanbyb);
              _this.$utils.setlocalStorage("ZhiYuandyd",map.ZhiYuandyd);
              _this.$utils.setlocalStorage("userZhiYuanBatch", response.data[0])
              _this.$utils.setlocalStorage('tianbaoModel', 0)
              _this.$utils.setlocalStorage('tianbaoType',  _this.tianbaoType);

              _this.$utils.removelocalStorage("zyyixuan");
              _this.$utils.setlocalStorage('zyadd',  {rate:_this.list[index].rate,type:_this.list[index].type});


              if (_this.tianbaoType == 0) {
                _this.$router.push('/zhuan_newgaokao')
              } else if (_this.tianbaoType != 0) {
                _this.$router.push('/zhuan_newgaokao')
              }
            }
          })
        }




        // this.cyc = this.$utils.getlocalStorage("ZhiYuancyc");
        // this.wyw = this.$utils.getlocalStorage("ZhiYuanwyw");
        // this.byb = this.$utils.getlocalStorage("ZhiYuanbyb");
        // this.dyd = this.$utils.getlocalStorage("ZhiYuandyd");

      },
      deleteZy(index) {
        this.list.splice(index, 1);
        this.getAlldata();
        this.$forceUpdate()
      },
      handleExport() {
        let name = this.AREA_OBJ[this.volunteerTableInfo.spare] + '_' + this.volunteerTableInfo.volunteerBatch + '_'
        name += this.userInfo.userName + '_' + this.SUBJECTTYPEOBJ[this.volunteerTableInfo.volunteerSubject] + '_'
        name += (this.volunteerTableInfo.volunteerName == "未定义" ?this.$utils.getShowYear()+'年院校优先优化志愿单' : this.volunteerTableInfo
          .volunteerName)
        this.dochuflag = true
        this.$nextTick(() => {
          downloadPDF(this.$refs.main_r, name, this.daochusunccess);
        })
      },
      ExportExcel() {
        console.log(234)
        let _this = this
        this.exportFlag = true;
        let obj = JSON.parse(JSON.stringify(this.volunteerTableInfo));
        obj.spare4 = this.tianbaoType;
        this.$req.ExportExcel(obj).then(function(response) {
          _this.exportFlag = false;
          if (response.status == "0") {
            let filename = response.data;
            //let url = window.URL.createObjectURL(new Blob([data]))
            let link = document.createElement('a')
            link.style.display = 'none'
            link.href = _this.$resourcesUrl + "/data/VolunteerTable" + filename;
            link.setAttribute('download', filename.split("/")[0]);
            document.body.appendChild(link)
            link.click()
            // _this.title = "保存成功"
            // _this.toastflag = true
            // _this.message = "您的志愿信息已经保存成功"
            // _this.fun = "to"
          }
        })
      },
      daochusunccess(flag) {
        this.dochuflag = false;
      },
      delMajor(index, index1) {
        this.list[index].ids.splice(index1, 1);
        this.list[index].list.splice(index1, 1);
        if (this.list[index].list.length == 0) {
          this.list.splice(index, 1);
        }
        this.getAlldata();
      },
      to() {

      },
      save() {
        let _this = this;
        // this.list.forEach(function(id) {
        //   list.push(_this.map[id])
        // })


        this.volunteerTableInfo.volunteerMajor = this.majornum,
          this.volunteerTableInfo.volunteerCollege = this.collegenum,
          this.volunteerTableInfo.volunteerNum = this.list.length,
          this.volunteerTableInfo.dataStr = JSON.stringify(this.list)

        _this.saveFlag = true;
        this.$req.update("volunteerTable", this.volunteerTableInfo).then(function(response) {
        _this.saveFlag = false;
          _this.$alert(response.message, '操作提示', {
            confirmButtonText: '确定',
            callback: action => {
              this.$message({
                type: 'info',
                message: `action: ${ action }`
              });
            }
          });
        })
      },
      getxuanke() {
        let xuanke = this.scoreInfo.scoreXuanke.split(",");
        let str = "";
        xuanke.forEach(function(item) {
          switch (item) {
            case 'wl':
              str += "物+";
              break;
            case 'ls':
              str += "历+";
              break;
            case 'hx':
              str += "化+";
              break;
            case 'sw':
              str += "生+";
              break;
            case 'dl':
              str += "地+";
              break;
            case 'zz':
              str += "政+";
              break;
            case 'xxjs':
              str += "信息+";
              break;
          }
        })
        return str.substring(0, str.length - 1)
      },
      updatesort(index, flag) {
        let _this = this;
        if (this.list.length != 1) {
          if ((flag && index != 0) || (!flag && index != this.list.length - 1)) {
            let obj = this.list[index]
            let n = index + 1
            if (flag) {
              //上调
              n = index - 1
            }
            _this.list[index] = _this.list[n]
            _this.list[n] = obj
            _this.list[index].show = true;
            _this.list[n].show = true;
            _this.list[index].flag = false;
            _this.list[n].flag = false;
            this.$forceUpdate()
            this.$nextTick(()=>{
            _this.list[index].flag = true;
            _this.list[n].flag = true;
            })
          }
        }
        // this.getAlldata();
        this.$forceUpdate()
      },
      changMajorsort(index, index1, flag) {
        let _this = this;
        if ((flag && index1 != 0) || (!flag && index1 != this.list[index].list.length - 1)) {
          let obj = this.list[index].list[index1]

          let n = 0
          if (flag) {
            //上调
            n = index1 - 1
          } else {
            n = index1 + 1
          }
          this.list[index].list[index1] = this.list[index].list[n]
          this.list[index].list[n] = obj

          if (this.list[index].ids != null) {
            this.list[index].ids[index1] = this.list[index].ids[n]
            let id = this.list[index].ids[index1]
            this.list[index].ids[n] = id

          }
          this.list[index].list[index1].flag = false;
          this.list[index].list[n].flag = false;
          this.$nextTick(()=>{
            _this.list[index].list[index1].flag = true;
            _this.list[index].list[n].flag = true;
          })
          this.$forceUpdate()
        }
      },


      getempty(str) {
        if (str == null || str == '') {
          return '--';
        }
        return str;
      },
      openShutManager(index, id) {
        this.list[index].show = !this.list[index].show
        //this.map[id].show = !this.map[id].show
      },
    }


  }
</script>

<style scoped>
  .generateList {
    margin-top: 20px;
  }

  .majorinfo {
    margin-top: 5px;
    width: 400px;
  }

  .majorinfo .info {
    font-size: 12px;
    color: #999999 !important;
  }

  .majorinfo p {
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: 500;
    line-height: 25px;
    color: #666666;
    margin-left: 0px !important;
  }

  .zhankaiNeirong {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .generateList li .item .itemRigth .btn,.generateList li .item .itemRigth .add,.generateList li .item .itemRigth .del{
    height: 23px;
  }

  .zymajor {
    width: 95%;
  }



  .beijngsd {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100px;
    margin-top: 70px;
    background: url(../../assets/gerenzhongxin/geren21.png)no-repeat;
    background-size: 100% 100%;
    font-size: 28px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #FFFFFF;
  }

  .beijngsd span {
    display: flex;
    width: 44px;
    height: 2px;
    opacity: 0.48;
    border-radius: 1px;
    background-color: #FFFFFF;
  }

  .beijngsd span:nth-of-type(1) {
    margin-right: 14px;
  }

  .beijngsd span:nth-of-type(2) {
    margin-left: 14px;
  }

  .centen {
    width: 1280px;
    margin: 0 auto;
  }

  .manpin {
    width: 100%;
    height: auto;
    padding: 40px 0;
    box-sizing: border-box;
    background:  #ebeef5d6;
  }

  .main {
    padding-bottom: 40px;
    display: flex;
    justify-content: space-between;
  }

  .main_l {
    background: rgba(251, 251, 251, 1);
    width: 290px;
  }



  .beijngsdtu {
    background: url(../../assets/gerenzhongxin/geren26.png)no-repeat;
    background-size: 100% 100%;
  }

  .texts {
    color: #F53824 !important;
  }

  .xiaoxi {
    margin-left: 10px;
    background: url(../../assets/gerenzhongxin/geren18.png)no-repeat;
    background-size: 100% 100%;
    width: 33px;
    height: 23px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
  }

  .main_r {
    width: 1070px;
    /* height: 878px; */
    background: rgba(255, 255, 255, 1);
    opacity: 1;
    border-radius: 5px;
    padding: 20px;
    box-sizing: border-box;
  }

  /* 新改的 */
  .mainr_top {
    width: 100%;
    height: 68px;
    display: flex;
    align-items: center;
    border-bottom: 1px solid rgba(0, 0, 0, 0.10196078431372549);
    justify-content: space-between;
  }

  .mainr_top .wenz_l {
    display: flex;
    align-items: center;
    font-size: 20px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #333333;
  }

  .mainr_top .wenz_l img {
    width: 7px;
    height: 24px;
    margin-right: 10px;
  }

  .wenz_r {
    display: flex;
    align-items: center;
  }

  .wenz_r .wenz_r_l {
    margin-right: 20px;
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 130px;
    height: 40px;
    background: linear-gradient(131deg, #F45D26 0%, #F53824 100%);
    box-shadow: 0px 0px 10px rgba(245, 56, 36, 0.4);
    opacity: 1;
    border-radius: 5px;
  }

  .wenz_r .wenz_r_r {
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 130px;
    height: 40px;
    background: linear-gradient(131deg, #29A7E1 0%, #249AD1 100%);
    box-shadow: 0px 0px 10px rgba(41, 167, 225, 0.4);
    opacity: 1;
    border-radius: 5px;
  }



  /* 新改的 */

  .youxinxi {
    padding: 33px 20px 0 20px;
    width: 310px;
    height: 230px;
    background: rgba(253, 251, 247, 1);
    border: 1px solid #FBF5E9;
    opacity: 1;
    border-radius: 5px;
    position: absolute;
    top: 24px;
    right: 20px;
  }

  .mainr_bot {
    width: 100%;
    position: relative;
  }

  .youxinxi label {
    position: absolute;
    top: -14px;
    left: 20px;
    width: 92px;
    height: 28px;
    background: rgba(244, 166, 65, 1);
    opacity: 1;
    border-radius: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
  }

  .youxinxi figure {
    display: flex;
    margin-bottom: 13px;
  }

  .youxinxi figure img {
    margin-right: 4px;
    width: 18px;
    height: 20px;
  }

  .youxinxi figure figcaption {
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #5A4F40;
  }


  .shoujiinp {
    width: auto;
    display: flex;
    position: relative;
  }



  .inps {
    width: 118px;
    height: 40px;
  }

  .inps:nth-of-type(1) {
    margin-right: 9px;
  }

  .inps:nth-of-type(2) {
    margin-right: 9px;
  }

  .inpda {
    width: 372px;
    height: 40px;
    background: rgba(255, 255, 255, 0.39);
    opacity: 1;
  }
</style>



// WEBPACK FOOTER //
// src/views/mine/i_zyd_lao.vue